export const SET_STEPPER_LABEL = "SET_STEPPER_LABEL@CRUMB"
export const SET_NOTIFICATION_ARRAY = "SET_NOTIFICATION_ARRAY@CRUMB"